<script lang="ts" setup>
import {computed} from "vue";

const props = defineProps({
    media: Object,
    alt: String,
    title: String,
    sizes: String,
    focalPoint: String,
    maxWidth: [String, Number],
    minWidth: [String, Number],
    eager: Boolean,
    classes: {
        type: String,
        default: 'w-full h-full object-cover',
    },
});
console.log(props.media);
const alt = computed(() => props.alt || props.media.alt);

const placeholder =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIwIiBoZWlnaHQ9IjAiIHZpZXdCb3g9IjAgMCAwIDAiPjwvc3ZnPgo=';
</script>

<template>
    <picture v-if="media">
        <!--        <source-->
        <!--            v-if="minWidth"-->
        <!--            :media="`(max-width: ${minWithInPixels})`"-->
        <!--            :srcset="placeholder"-->
        <!--            class="hidden"-->
        <!--        >-->
        <!--        <source-->
        <!--            v-if="maxWidth"-->
        <!--            :media="`(min-width: ${getWithInPixels(maxWidth)})`"-->
        <!--            :srcset="placeholder"-->
        <!--            class="hidden"-->
        <!--        >-->

        <img
            :alt="alt"
            :class="classes"
            :loading="eager ? 'eager' : 'lazy'"
            :sizes="sizes"
            :src="media.src"
            :srcSet="media.src_set"
            :style="focalPoint ? `object-position: ${focalPoint};` : ''"
            :title="title"
            draggable="false"
        >
    </picture>
</template>
